import { render, staticRenderFns } from "./deadline.vue?vue&type=template&id=008c0acf"
import script from "./deadline.vue?vue&type=script&lang=js"
export * from "./deadline.vue?vue&type=script&lang=js"
import style0 from "./deadline.vue?vue&type=style&index=0&id=008c0acf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports